import UserPermission from '../../UserPermission';
import api from '../../../services/api';
import { convertTimestampToDay } from '../../../pages/utils/convertTimestampToDay';

/* Permissão do usuário no sistema */
const userPermission = UserPermission();

async function getObjectsWithNames(route) {
    return await api.get(`${userPermission}/${route}`).then(response => {
        return response.data;
    });
}

// Formato do retorno da função
// {
//   nome: {
//       Novo,
//       Em análise,
//       Indeferido,
//       Resolvido,
//       totalServiceTime,
//       quantOccurrences
//   }
// }
function getObjectSeparetedByName(names, statusNames) {
    let objectByName = {};

    names.forEach((name) => {
        let obj = {
            name: name.name,
            totalServiceTime: 0,
            totalTimeToResponse: 0,
            quantOccurrences: 0
        };

        statusNames.forEach((statusName) => {
            obj[statusName] = 0;
        });

        objectByName[name.name] = obj;
    });

    return objectByName;
}

function addInfo(occurrences, separateInObject, nameObject) {
    occurrences.forEach((occurrence) => {
        try {
            const attrOccurrence = occurrence[nameObject];

            separateInObject[attrOccurrence][occurrence.status]++;

            if (occurrence.status === "Em análise")
                separateInObject[attrOccurrence].totalServiceTime += (
                    new Date(occurrence.updatedAt) - new Date(occurrence.createdAt)
                );

            if (occurrence.status === "Resolvido")
                separateInObject[attrOccurrence].totalTimeToResponse += (
                    new Date(occurrence.updatedAt) - new Date(occurrence.createdAt)
                );

            separateInObject[attrOccurrence].quantOccurrences++;
        } catch (err) {
            // console.error(err);
        }

    });
}

//Deverá retornar um array de objetos
function addInformation(occurrences, names, nameObject) {
    const statusNames = ["Novo", "Em análise", "Resolvido", "Indeferido"];

    let separateInObject = getObjectSeparetedByName(names, statusNames);
    addInfo(occurrences, separateInObject, nameObject);//Altera o separateInObject

    let objectsWithInfo = Object.values(separateInObject);

    //Ordena descrescentemente pela quantidade de ocorrências em cada bairro
    objectsWithInfo.sort(function (a, b) {
        return b.quantOccurrences - a.quantOccurrences;
    });

    objectsWithInfo.forEach((objectWithInfo) => {
        const timestampByOccurrence = objectWithInfo.totalServiceTime / objectWithInfo["Em análise"];
        objectWithInfo.totalServiceTime = convertTimestampToDay(timestampByOccurrence);

        const timestampRespondeByOccurrence = objectWithInfo.totalTimeToResponse / objectWithInfo["Resolvido"];
        objectWithInfo.totalTimeToResponse = convertTimestampToDay(timestampRespondeByOccurrence);
    });

    return objectsWithInfo;
}

export async function getInfoTables({ occurrences, nameObject, route }) {
    const names = await getObjectsWithNames(route);
    return addInformation(occurrences, names, nameObject);
}